/**
 * FilmGrain — quiet noise overlay that gives big surfaces a printed-magazine
 * feel. Pure SVG; no extra HTTP request. Renders as a non-interactive
 * `absolute inset-0` div, so place it inside a `position: relative` parent.
 *
 * @example
 *   <section className="relative bg-[color:var(--charcoal)]">
 *     <FilmGrain opacity={0.05} />
 *     ...content...
 *   </section>
 */
import React, { useId } from "react";

export default function FilmGrain({
  opacity = 0.04,
  tone = "warm",     // warm = cream-leaning grain, cool = charcoal-leaning
  blendMode = "overlay",
  className = "",
  ...rest
}) {
  const id = useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const svg = `
    <svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'>
      <filter id='n${id}'>
        <feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/>
        <feColorMatrix type='matrix' values='0 0 0 0 ${tone === "warm" ? "0.78" : "0.06"}  0 0 0 0 ${tone === "warm" ? "0.69" : "0.05"}  0 0 0 0 ${tone === "warm" ? "0.54" : "0.04"}  0 0 0 0.55 0'/>
      </filter>
      <rect width='100%' height='100%' filter='url(#n${id})'/>
    </svg>`;
  const url = `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 ${className}`}
      style={{
        backgroundImage: url,
        backgroundSize: "240px 240px",
        opacity,
        mixBlendMode: blendMode,
      }}
      {...rest}
    />
  );
}
